// RepairResponse schema — API response shape for POST /repair/item.
//
// Session 39: extracted from packages/web/src/api/repair.ts (TS-only interface)
// into a shared Zod schema so both frontend (safeParse) and backend (.parse())
// enforce the contract at runtime.
//
// Three-variant discriminated union on `status`:
//   success       — LLM produced a schema-valid repaired item
//   schema_fail   — LLM output failed the item-kind schema
//   provider_error — LLM call itself failed (network, rate-limit, etc.)
import { z } from 'zod';
import { GuardReportSchema } from './repair.js';
import { RepairFailureKindSchema } from './repair.js';
/** Common LLM telemetry fields — present on both success and schema_fail. */
const LlmTelemetrySchema = z.object({
    providerName: z.string(),
    modelKey: z.string(),
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    costRmb: z.number().nonnegative(),
    durationMs: z.number().int().nonnegative(),
    promptVersion: z.string(),
});
export const RepairResponseSchema = z.discriminatedUnion('status', [
    // ── success: LLM output passed the item-kind schema + mutability guard ──
    z.object({
        status: z.literal('success'),
        output: z.unknown(),
        ...LlmTelemetrySchema.shape,
        /** 19AV Phase B: server-side mutability enforcement record. */
        guardReport: GuardReportSchema,
        /** Present iff the guard reverted any locked field. */
        failureKind: RepairFailureKindSchema.optional(),
    }),
    // ── schema_fail: LLM output failed the item-kind schema ──
    z.object({
        status: z.literal('schema_fail'),
        schemaErrors: z.array(z.string()),
        rawOutput: z.unknown(),
        ...LlmTelemetrySchema.shape,
        failureKind: z.literal('schema_violation'),
    }),
    // ── provider_error: LLM call itself failed ──
    z.object({
        status: z.literal('provider_error'),
        message: z.string(),
        durationMs: z.number().int().nonnegative(),
    }),
]);
//# sourceMappingURL=repair-response.js.map